/**
 * "How to read the map" (client, 12 Oct 2026, NOTES #760): a compact block under the UC3
 * blurb, collapsed by default, one line per Relationships class: its colour, its plain
 * label and the generic sentence ("the factor" in place of the factor's name). From the
 * locale files (`intel.uc3.lbr.plain`/`hint`/`subject.generic`), not from `uc3.json`, so it
 * reads the same words as the legend and the result cards.
 */
import { useTranslation } from 'react-i18next';

import { LBR_CLASS_COLORS } from '../../lib/analysis';
import { LBR_LEGEND_ORDER, lbrLabel, lbrMethodTerm, lbrSentence } from './lbrClasses';

export function Uc3Reading() {
  const { t } = useTranslation();
  return (
    <details className="uc3-reading" id="uc3Reading">
      <summary>{t('intel.uc3.lbr.reading.title')}</summary>
      <p>{t('intel.uc3.lbr.reading.intro')}</p>
      <ul>
        {LBR_LEGEND_ORDER.map((key) => (
          <li key={key} data-lbr-class={key} title={lbrMethodTerm(t, key)}>
            <span className="swatch" style={{ background: LBR_CLASS_COLORS[key] }} aria-hidden="true" />
            <span className="uc3-reading-label">{lbrLabel(t, key)}</span>
            <span className="uc3-reading-text">{lbrSentence(t, key, 'generic')}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}

export default Uc3Reading;
